// import { useEffect, useMemo, useState } from "react";
// import dayjs from "dayjs";
// import * as Constants from "../../constants/constants";
// import "./InvoiceGenerated.css";

// const blankItem = { desc: "", qty: 1, rate: 0, amount: 0 };
// const defaultTheme = { primary: "#0b5fff", accent: "#111827" };

// export default function AccountInvoicePage() {
//   const [org, setOrg] = useState({
//     name: "Your Company",
//     address: "Address",
//     phone: "",
//     email: "",
//     gstin: "",
//     pan: "",
//     logoUrl: "",
//     signatureUrl: "",
//     theme: defaultTheme,
//     bank: { name: "", accNo: "", ifsc: "", branch: "" },
//     terms: [
//       "Payment due within 7 days unless otherwise agreed.",
//       "Please quote invoice number on payment.",
//     ],
//   });

//   const [customer, setCustomer] = useState({
//     name: "",
//     email: "",
//     address: "",
//   });

//   const [invoice, setInvoice] = useState({
//     code: `INV-${dayjs().format("YYYYMMDD-HHmmss")}`,
//     date: dayjs().format("YYYY-MM-DD"),
//     notes: "",
//     currency: "INR",
//   });

//   const [items, setItems] = useState([{ ...blankItem }]);
//   const [taxPct, setTaxPct] = useState(18);
//   const [emailNow, setEmailNow] = useState(false);
//   const [emailTo, setEmailTo] = useState("");
//   const [downloadUrl, setDownloadUrl] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [list, setList] = useState([]);
//   const [mailing, setMailing] = useState(false);

//   const [logoPreview, setLogoPreview] = useState("");
//   const [signPreview, setSignPreview] = useState("");

//   useEffect(() => {
//     loadList();
//   }, []);

//   const loadList = async () => {
//     try {
//       const response = await fetch(`${Constants.API_URL}/accounts/invoices`);
//       const data = await response.json();

//       if (response.ok) {
//         setList(data.rows || []);
//       }
//     } catch (error) {
//       console.error("Invoice List Error:", error);
//     }
//   };

//   const uploadImage = async (file) => {
//     const formData = new FormData();
//     formData.append("file", file);

//     const response = await fetch(`${Constants.API_URL}/accounts/upload`, {
//       method: "POST",
//       body: formData,
//     });

//     const data = await response.json();

//     if (!response.ok) {
//       throw new Error(data.error || "Upload failed");
//     }

//     return data.url;
//   };

//   const totals = useMemo(() => {
//     const subtotal = items.reduce((sum, item) => {
//       const qty = Number(item.qty || 0);
//       const rate = Number(item.rate || 0);
//       const amount = item.amount != null ? Number(item.amount) : qty * rate;
//       return sum + amount;
//     }, 0);

//     const taxAmount = (subtotal * Number(taxPct || 0)) / 100;

//     return {
//       subtotal,
//       taxPct: Number(taxPct || 0),
//       taxAmt: taxAmount,
//       grandTotal: subtotal + taxAmount,
//     };
//   }, [items, taxPct]);

//   const setItem = (index, patch) => {
//     setItems((prev) => {
//       const copy = [...prev];
//       const row = { ...copy[index], ...patch };

//       const qty = Number(row.qty || 0);
//       const rate = Number(row.rate || 0);

//       row.amount = +(qty * rate).toFixed(2);
//       copy[index] = row;

//       return copy;
//     });
//   };

//   const addItem = () => {
//     setItems((prev) => [...prev, { ...blankItem }]);
//   };

//   const removeItem = (index) => {
//     setItems((prev) => {
//       if (prev.length === 1) return prev;
//       return prev.filter((_, idx) => idx !== index);
//     });
//   };

//   const resetForm = () => {
//     setCustomer({ name: "", email: "", address: "" });
//     setInvoice({
//       code: `INV-${dayjs().format("YYYYMMDD-HHmmss")}`,
//       date: dayjs().format("YYYY-MM-DD"),
//       notes: "",
//       currency: "INR",
//     });
//     setItems([{ ...blankItem }]);
//     setTaxPct(18);
//     setEmailNow(false);
//     setEmailTo("");
//     setDownloadUrl("");
//   };

//   const sendExisting = async (fileName, to) => {
//     setMailing(true);

//     try {
//       const response = await fetch(`${Constants.API_URL}/accounts/send`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           "x-role": "account",
//         },
//         body: JSON.stringify({ fileName, to }),
//       });

//       const data = await response.json();

//       if (!response.ok) {
//         throw new Error(data.error || "Failed");
//       }
//     } finally {
//       setMailing(false);
//     }
//   };

//   const submit = async () => {
//     if (!customer.name.trim()) {
//       alert("Please enter customer name");
//       return;
//     }

//     if (!items.some((item) => item.desc && Number(item.amount) > 0)) {
//       alert("Please add at least one valid item");
//       return;
//     }

//     setLoading(true);

//     try {
//       const body = {
//         org,
//         customer,
//         invoice,
//         items,
//         totals,
//         emailNow,
//         emailTo,
//       };

//       const response = await fetch(`${Constants.API_URL}/accounts/invoice`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           "x-role": emailNow ? "account" : "guest",
//         },
//         body: JSON.stringify(body),
//       });

//       const data = await response.json();

//       if (!response.ok) {
//         throw new Error(data.error || "Failed");
//       }

//       setDownloadUrl(data.url);
//       await loadList();

//       if (!emailNow) {
//         const want = window.confirm(
//           "Invoice generated. Do you want to email it now?"
//         );

//         if (want) {
//           const to = prompt(
//             "Send to email:",
//             customer.email || ""
//           );

//           if (to !== null) {
//             await sendExisting(data.fileName, to || customer.email);
//             alert("Email sent.");
//           }
//         }
//       } else {
//         alert("Invoice generated and emailed.");
//       }
//     } catch (error) {
//       alert(error.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const formatMoney = (amount) => {
//     return `₹${Number(amount || 0).toFixed(2)}`;
//   };

//   return (
//     <div className="unit-page invoice-gen-theme">
//       <div className="unit-header">
//         <div>
//           <div className="unit-page-label">Accounts</div>
//           <h2>Invoice Generator</h2>
//           <p>Create invoices, upload logo/signature, generate PDF and email invoices.</p>
//         </div>

//         <div className="unit-header-actions">
//           <button className="unit-btn unit-btn-light" onClick={loadList}>
//             <i className="fa-solid fa-rotate" aria-hidden="true"></i>
//             Refresh
//           </button>

//           <button className="unit-btn unit-btn-light" onClick={resetForm}>
//             <i className="fa-solid fa-rotate-left" aria-hidden="true"></i>
//             Reset
//           </button>

//           <button
//             className="unit-btn unit-btn-primary"
//             onClick={submit}
//             disabled={loading}
//           >
//             <i className="fa-solid fa-file-pdf" aria-hidden="true"></i>
//             {loading ? "Working..." : "Generate PDF"}
//           </button>
//         </div>
//       </div>

//       <div className="unit-stats-row invoice-one-line-cards">
//         <div className="unit-stat-card">
//           <div className="invoice-stat-icon">
//             <i className="fa-solid fa-file-invoice" aria-hidden="true"></i>
//           </div>
//           <div>
//             <span>Invoice No.</span>
//             <strong className="invoice-stat-code">{invoice.code}</strong>
//           </div>
//         </div>

//         <div className="unit-stat-card">
//           <div className="invoice-stat-icon">
//             <i className="fa-solid fa-box" aria-hidden="true"></i>
//           </div>
//           <div>
//             <span>Items</span>
//             <strong>{items.length}</strong>
//           </div>
//         </div>

//         <div className="unit-stat-card">
//           <div className="invoice-stat-icon">
//             <i className="fa-solid fa-sack-dollar" aria-hidden="true"></i>
//           </div>
//           <div>
//             <span>Subtotal</span>
//             <strong>{formatMoney(totals.subtotal)}</strong>
//           </div>
//         </div>

//         <div className="unit-stat-card">
//           <div className="invoice-stat-icon">
//             <i className="fa-solid fa-percent" aria-hidden="true"></i>
//           </div>
//           <div>
//             <span>Tax</span>
//             <strong>{formatMoney(totals.taxAmt)}</strong>
//           </div>
//         </div>

//         <div className="unit-stat-card">
//           <div className="invoice-stat-icon invoice-stat-icon-primary">
//             <i className="fa-solid fa-coins" aria-hidden="true"></i>
//           </div>
//           <div>
//             <span>Grand Total</span>
//             <strong>{formatMoney(totals.grandTotal)}</strong>
//           </div>
//         </div>
//       </div>

//       <div className="row g-4">
//         <div className="col-lg-6">
//           <div className="unit-card h-100">
//             <div className="unit-toolbar">
//               <div>
//                 <h5>
//                   <i className="fa-solid fa-building" aria-hidden="true"></i>
//                   Organization Details
//                 </h5>
//                 <p>Company, tax, logo, signature and bank information.</p>
//               </div>
//             </div>

//             <div className="p-3">
//               <div className="row g-3">
//                 <div className="col-12">
//                   <label className="form-label" htmlFor="inv-org-name">Company Name</label>
//                   <input
//                     id="inv-org-name"
//                     className="form-control"
//                     value={org.name}
//                     onChange={(e) => setOrg({ ...org, name: e.target.value })}
//                     placeholder="Company Name"
//                   />
//                 </div>

//                 <div className="col-12">
//                   <label className="form-label" htmlFor="inv-org-address">Address</label>
//                   <textarea
//                     id="inv-org-address"
//                     className="form-control"
//                     rows={3}
//                     value={org.address}
//                     onChange={(e) =>
//                       setOrg({ ...org, address: e.target.value })
//                     }
//                     placeholder="Address"
//                   />
//                 </div>

//                 <div className="col-md-6">
//                   <label className="form-label" htmlFor="inv-org-phone">Phone</label>
//                   <input
//                     id="inv-org-phone"
//                     className="form-control"
//                     value={org.phone}
//                     onChange={(e) => setOrg({ ...org, phone: e.target.value })}
//                     placeholder="Phone"
//                   />
//                 </div>

//                 <div className="col-md-6">
//                   <label className="form-label" htmlFor="inv-org-email">Email</label>
//                   <input
//                     id="inv-org-email"
//                     className="form-control"
//                     value={org.email}
//                     onChange={(e) => setOrg({ ...org, email: e.target.value })}
//                     placeholder="Email"
//                   />
//                 </div>

//                 <div className="col-md-6">
//                   <label className="form-label" htmlFor="inv-org-gstin">GSTIN</label>
//                   <input
//                     id="inv-org-gstin"
//                     className="form-control"
//                     value={org.gstin}
//                     onChange={(e) => setOrg({ ...org, gstin: e.target.value })}
//                     placeholder="GSTIN"
//                   />
//                 </div>

//                 <div className="col-md-6">
//                   <label className="form-label" htmlFor="inv-org-pan">PAN</label>
//                   <input
//                     id="inv-org-pan"
//                     className="form-control"
//                     value={org.pan}
//                     onChange={(e) => setOrg({ ...org, pan: e.target.value })}
//                     placeholder="PAN"
//                   />
//                 </div>

//                 <div className="col-md-6">
//                   <label className="form-label" htmlFor="inv-org-logo">Logo Upload</label>
//                   <input
//                     id="inv-org-logo"
//                     type="file"
//                     accept="image/*"
//                     className="form-control"
//                     onChange={async (e) => {
//                       const file = e.target.files?.[0];
//                       if (!file) return;

//                       const url = await uploadImage(file);
//                       setOrg({ ...org, logoUrl: url });
//                       setLogoPreview(url);
//                     }}
//                   />

//                   {(logoPreview || org.logoUrl) && (
//                     <img
//                       src={logoPreview || org.logoUrl}
//                       alt="logo"
//                       style={{ height: 48, marginTop: 8 }}
//                     />
//                   )}
//                 </div>

//                 <div className="col-md-6">
//                   <label className="form-label" htmlFor="inv-org-signature">Signature Upload</label>
//                   <input
//                     id="inv-org-signature"
//                     type="file"
//                     accept="image/*"
//                     className="form-control"
//                     onChange={async (e) => {
//                       const file = e.target.files?.[0];
//                       if (!file) return;

//                       const url = await uploadImage(file);
//                       setOrg({ ...org, signatureUrl: url });
//                       setSignPreview(url);
//                     }}
//                   />

//                   {(signPreview || org.signatureUrl) && (
//                     <img
//                       src={signPreview || org.signatureUrl}
//                       alt="signature"
//                       style={{ height: 48, marginTop: 8 }}
//                     />
//                   )}
//                 </div>

//                 <div className="col-md-6">
//                   <label className="form-label" htmlFor="inv-org-color-primary">Brand Color</label>
//                   <input
//                     id="inv-org-color-primary"
//                     type="color"
//                     className="form-control form-control-color"
//                     value={org.theme.primary}
//                     onChange={(e) =>
//                       setOrg({
//                         ...org,
//                         theme: { ...org.theme, primary: e.target.value },
//                       })
//                     }
//                   />
//                 </div>

//                 <div className="col-md-6">
//                   <label className="form-label" htmlFor="inv-org-color-accent">Accent Color</label>
//                   <input
//                     id="inv-org-color-accent"
//                     type="color"
//                     className="form-control form-control-color"
//                     value={org.theme.accent}
//                     onChange={(e) =>
//                       setOrg({
//                         ...org,
//                         theme: { ...org.theme, accent: e.target.value },
//                       })
//                     }
//                   />
//                 </div>

//                 <div className="col-12">
//                   <h6 className="mt-2 mb-0">Bank Details</h6>
//                 </div>

//                 <div className="col-12">
//                   <input
//                     className="form-control"
//                     placeholder="Bank Name"
//                     aria-label="Bank Name"
//                     value={org.bank.name}
//                     onChange={(e) =>
//                       setOrg({
//                         ...org,
//                         bank: { ...org.bank, name: e.target.value },
//                       })
//                     }
//                   />
//                 </div>

//                 <div className="col-md-6">
//                   <input
//                     className="form-control"
//                     placeholder="A/C No"
//                     aria-label="Account Number"
//                     value={org.bank.accNo}
//                     onChange={(e) =>
//                       setOrg({
//                         ...org,
//                         bank: { ...org.bank, accNo: e.target.value },
//                       })
//                     }
//                   />
//                 </div>

//                 <div className="col-md-6">
//                   <input
//                     className="form-control"
//                     placeholder="IFSC"
//                     aria-label="IFSC Code"
//                     value={org.bank.ifsc}
//                     onChange={(e) =>
//                       setOrg({
//                         ...org,
//                         bank: { ...org.bank, ifsc: e.target.value },
//                       })
//                     }
//                   />
//                 </div>

//                 <div className="col-12">
//                   <input
//                     className="form-control"
//                     placeholder="Branch"
//                     aria-label="Branch"
//                     value={org.bank.branch}
//                     onChange={(e) =>
//                       setOrg({
//                         ...org,
//                         bank: { ...org.bank, branch: e.target.value },
//                       })
//                     }
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="col-lg-6">
//           <div className="unit-card h-100">
//             <div className="unit-toolbar">
//               <div>
//                 <h5>
//                   <i className="fa-solid fa-user" aria-hidden="true"></i>
//                   Customer & Invoice
//                 </h5>
//                 <p>Customer contact, invoice code, date and notes.</p>
//               </div>
//             </div>

//             <div className="p-3">
//               <div className="row g-3">
//                 <div className="col-12">
//                   <label className="form-label" htmlFor="inv-cust-name">Customer Name</label>
//                   <input
//                     id="inv-cust-name"
//                     className="form-control"
//                     value={customer.name}
//                     onChange={(e) =>
//                       setCustomer({ ...customer, name: e.target.value })
//                     }
//                     placeholder="Customer Name"
//                   />
//                 </div>

//                 <div className="col-12">
//                   <label className="form-label" htmlFor="inv-cust-email">Customer Email</label>
//                   <input
//                     id="inv-cust-email"
//                     className="form-control"
//                     value={customer.email}
//                     onChange={(e) =>
//                       setCustomer({ ...customer, email: e.target.value })
//                     }
//                     placeholder="Customer Email"
//                   />
//                 </div>

//                 <div className="col-12">
//                   <label className="form-label" htmlFor="inv-cust-address">Customer Address</label>
//                   <textarea
//                     id="inv-cust-address"
//                     className="form-control"
//                     rows={3}
//                     value={customer.address}
//                     onChange={(e) =>
//                       setCustomer({ ...customer, address: e.target.value })
//                     }
//                     placeholder="Customer Address"
//                   />
//                 </div>

//                 <div className="col-md-6">
//                   <label className="form-label" htmlFor="inv-code">Invoice Code</label>
//                   <input
//                     id="inv-code"
//                     className="form-control"
//                     value={invoice.code}
//                     onChange={(e) =>
//                       setInvoice({ ...invoice, code: e.target.value })
//                     }
//                     placeholder="Invoice Code"
//                   />
//                 </div>

//                 <div className="col-md-6">
//                   <label className="form-label" htmlFor="inv-date">Invoice Date</label>
//                   <input
//                     id="inv-date"
//                     className="form-control"
//                     type="date"
//                     value={invoice.date}
//                     onChange={(e) =>
//                       setInvoice({ ...invoice, date: e.target.value })
//                     }
//                   />
//                 </div>

//                 <div className="col-12">
//                   <label className="form-label" htmlFor="inv-notes">Notes</label>
//                   <textarea
//                     id="inv-notes"
//                     className="form-control"
//                     rows={3}
//                     value={invoice.notes}
//                     onChange={(e) =>
//                       setInvoice({ ...invoice, notes: e.target.value })
//                     }
//                     placeholder="Invoice notes"
//                   />
//                 </div>

//                 <div className="col-12">
//                   <div className="unit-card" style={{ boxShadow: "none" }}>
//                     <div className="p-3">
//                       <h6 className="mb-2">Email Option</h6>

//                       <label className="d-flex align-items-center gap-2">
//                         <input
//                           type="checkbox"
//                           checked={emailNow}
//                           onChange={(e) => setEmailNow(e.target.checked)}
//                         />
//                         Email invoice now
//                       </label>

//                       {emailNow && (
//                         <input
//                           className="form-control mt-3"
//                           placeholder="Send to email, optional"
//                           aria-label="Send invoice to email"
//                           value={emailTo}
//                           onChange={(e) => setEmailTo(e.target.value)}
//                         />
//                       )}

//                       {downloadUrl && (
//                         <a
//                           href={downloadUrl}
//                           target="_blank"
//                           rel="noreferrer"
//                           className="unit-btn unit-btn-light text-decoration-none mt-3 d-inline-block"
//                         >
//                           <i className="fa-solid fa-download" aria-hidden="true"></i>
//                           Download Last PDF
//                         </a>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Items */}
//       <div className="unit-card mt-4">
//         <div className="unit-toolbar">
//           <div>
//             <h5>
//               <i className="fa-solid fa-list-check" aria-hidden="true"></i>
//               Invoice Items
//             </h5>
//             <p>Add product/service rows with quantity, rate and calculated amount.</p>
//           </div>

//           <button className="unit-btn unit-btn-primary" onClick={addItem}>
//             <i className="fa-solid fa-plus" aria-hidden="true"></i>
//             Add Item
//           </button>
//         </div>

//         <div className="unit-table-wrapper">
//           <table className="table unit-table">
//             <thead>
//               <tr>
//                 <th>Description</th>
//                 <th style={{ width: "130px" }}>Qty</th>
//                 <th style={{ width: "150px" }}>Rate</th>
//                 <th style={{ width: "160px" }}>Amount</th>
//                 <th className="text-end" style={{ width: "90px" }}>
//                   Action
//                 </th>
//               </tr>
//             </thead>

//             <tbody>
//               {items.map((item, index) => (
//                 <tr key={index}>
//                   <td className="invoice-item-desc">
//                     <input
//                       className="form-control"
//                       value={item.desc}
//                       onChange={(e) =>
//                         setItem(index, { desc: e.target.value })
//                       }
//                       placeholder="Description"
//                       aria-label={`Item ${index + 1} description`}
//                     />
//                   </td>

//                   <td>
//                     <input
//                       className="form-control"
//                       type="number"
//                       step="0.01"
//                       value={item.qty}
//                       onChange={(e) =>
//                         setItem(index, { qty: e.target.value })
//                       }
//                       aria-label={`Item ${index + 1} quantity`}
//                     />
//                   </td>

//                   <td>
//                     <input
//                       className="form-control"
//                       type="number"
//                       step="0.01"
//                       value={item.rate}
//                       onChange={(e) =>
//                         setItem(index, { rate: e.target.value })
//                       }
//                       aria-label={`Item ${index + 1} rate`}
//                     />
//                   </td>

//                   <td>
//                     <input
//                       className="form-control"
//                       readOnly
//                       type="number"
//                       step="0.01"
//                       value={item.amount ?? 0}
//                       aria-label={`Item ${index + 1} amount`}
//                     />
//                   </td>

//                   <td>
//                     <div className="unit-actions">
//                       <button
//                         className="unit-icon-btn unit-delete"
//                         onClick={() => removeItem(index)}
//                         disabled={items.length === 1}
//                         title="Remove item"
//                         aria-label={`Remove item ${index + 1}`}
//                       >
//                         <i className="fa-solid fa-trash" aria-hidden="true"></i>
//                       </button>
//                     </div>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>

//         <div className="p-3 border-top">
//           <div className="row g-3 align-items-end">
//             <div className="col-md-2">
//               <label className="form-label" htmlFor="inv-tax-pct">Tax %</label>
//               <input
//                 id="inv-tax-pct"
//                 className="form-control"
//                 type="number"
//                 step="0.01"
//                 value={taxPct}
//                 onChange={(e) => setTaxPct(e.target.value)}
//               />
//             </div>

//             <div className="col-md-10">
//               <div className="invoice-total-strip">
//                 <div>
//                   <span>Subtotal</span>
//                   <strong>{formatMoney(totals.subtotal)}</strong>
//                 </div>

//                 <div>
//                   <span>Tax</span>
//                   <strong>{formatMoney(totals.taxAmt)}</strong>
//                 </div>

//                 <div>
//                   <span>Grand Total</span>
//                   <strong>{formatMoney(totals.grandTotal)}</strong>
//                 </div>

//                 <button
//                   className="unit-btn unit-btn-primary"
//                   onClick={submit}
//                   disabled={loading}
//                 >
//                   <i className="fa-solid fa-file-pdf" aria-hidden="true"></i>
//                   {loading ? "Working..." : "Generate PDF"}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Generated Invoices */}
//       <div className="unit-card mt-4">
//         <div className="unit-toolbar">
//           <div>
//             <h5>
//               <i className="fa-solid fa-file-invoice" aria-hidden="true"></i>
//               Generated Invoices
//             </h5>
//             <p>View, download and email previously generated invoice PDFs.</p>
//           </div>
//         </div>

//         <div className="unit-table-wrapper">
//           <table className="table unit-table">
//             <thead>
//               <tr>
//                 <th>File</th>
//                 <th>Size</th>
//                 <th>Modified</th>
//                 <th className="text-end" style={{ width: "230px" }}>
//                   Actions
//                 </th>
//               </tr>
//             </thead>

//             <tbody>
//               {list.length > 0 ? (
//                 list.map((file) => (
//                   <tr key={file.fileName}>
//                     <td>
//                       <div className="unit-name-box">
//                         <div className="unit-letter">I</div>

//                         <div>
//                           <a
//                             href={file.url}
//                             target="_blank"
//                             rel="noreferrer"
//                             className="text-decoration-none"
//                           >
//                             <strong>{file.fileName}</strong>
//                           </a>
//                           <small>Invoice PDF</small>
//                         </div>
//                       </div>
//                     </td>

//                     <td>
//                       <span className="unit-id">
//                         {(file.size / 1024).toFixed(1)} KB
//                       </span>
//                     </td>

//                     <td>
//                       {dayjs(file.mtime).format("YYYY-MM-DD HH:mm")}
//                     </td>

//                     <td>
//                       <div className="unit-actions">
//                         <button
//                           className="unit-btn unit-btn-light"
//                           disabled={mailing}
//                           aria-label={`Email ${file.fileName}`}
//                           onClick={async () => {
//                             const to = prompt("Email to:", customer.email || "");

//                             if (to) {
//                               await sendExisting(file.fileName, to);
//                               alert("Email sent.");
//                             }
//                           }}
//                         >
//                           <i className="fa-solid fa-envelope" aria-hidden="true"></i>
//                           Email
//                         </button>

//                         <a
//                           href={file.url}
//                           target="_blank"
//                           rel="noreferrer"
//                           className="unit-btn unit-btn-light text-decoration-none"
//                           aria-label={`Download ${file.fileName}`}
//                         >
//                           <i className="fa-solid fa-download" aria-hidden="true"></i>
//                           Download
//                         </a>
//                       </div>
//                     </td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan="4">
//                     <div className="unit-empty">
//                       <div className="unit-empty-icon">
//                         <i className="fa-solid fa-file-invoice" aria-hidden="true"></i>
//                       </div>
//                       <h5>No invoices yet</h5>
//                       <p>Generated invoices will appear here.</p>
//                     </div>
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>

//     </div>
//   );
// }





import { useEffect, useMemo, useState } from "react";
import dayjs from "dayjs";
import * as Constants from "../../constants/constants";
import "./InvoiceGenerated.css";

const blankItem = { desc: "", qty: 1, rate: 0, amount: 0 };
const defaultTheme = { primary: "#0b5fff", accent: "#111827" };

export default function AccountInvoicePage() {
  const [org, setOrg] = useState({
    name: "Your Company",
    address: "Address",
    phone: "",
    email: "",
    gstin: "",
    pan: "",
    logoUrl: "",
    signatureUrl: "",
    theme: defaultTheme,
    bank: { name: "", accNo: "", ifsc: "", branch: "" },
    terms: [
      "Payment due within 7 days unless otherwise agreed.",
      "Please quote invoice number on payment.",
    ],
  });

  const [customer, setCustomer] = useState({
    name: "",
    email: "",
    address: "",
  });

  const [invoice, setInvoice] = useState({
    code: `INV-${dayjs().format("YYYYMMDD-HHmmss")}`,
    date: dayjs().format("YYYY-MM-DD"),
    notes: "",
    currency: "INR",
  });

  const [items, setItems] = useState([{ ...blankItem }]);
  const [taxPct, setTaxPct] = useState(18);
  const [emailNow, setEmailNow] = useState(false);
  const [emailTo, setEmailTo] = useState("");
  const [downloadUrl, setDownloadUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const [mailing, setMailing] = useState(false);

  const [logoPreview, setLogoPreview] = useState("");
  const [signPreview, setSignPreview] = useState("");

  useEffect(() => {
    loadList();
  }, []);

  const loadList = async () => {
    try {
      const response = await fetch(`${Constants.API_URL}/accounts/invoices`);
      const data = await response.json();

      if (response.ok) {
        setList(data.rows || []);
      }
    } catch (error) {
      console.error("Invoice List Error:", error);
    }
  };

  const uploadImage = async (file) => {
    const formData = new FormData();
    formData.append("file", file);

    const response = await fetch(`${Constants.API_URL}/accounts/upload`, {
      method: "POST",
      body: formData,
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || "Upload failed");
    }

    return data.url;
  };

  const totals = useMemo(() => {
    const subtotal = items.reduce((sum, item) => {
      const qty = Number(item.qty || 0);
      const rate = Number(item.rate || 0);
      const amount = item.amount != null ? Number(item.amount) : qty * rate;
      return sum + amount;
    }, 0);

    const taxAmount = (subtotal * Number(taxPct || 0)) / 100;

    return {
      subtotal,
      taxPct: Number(taxPct || 0),
      taxAmt: taxAmount,
      grandTotal: subtotal + taxAmount,
    };
  }, [items, taxPct]);

  const setItem = (index, patch) => {
    setItems((prev) => {
      const copy = [...prev];
      const row = { ...copy[index], ...patch };

      const qty = Number(row.qty || 0);
      const rate = Number(row.rate || 0);

      row.amount = +(qty * rate).toFixed(2);
      copy[index] = row;

      return copy;
    });
  };

  const addItem = () => {
    setItems((prev) => [...prev, { ...blankItem }]);
  };

  const removeItem = (index) => {
    setItems((prev) => {
      if (prev.length === 1) return prev;
      return prev.filter((_, idx) => idx !== index);
    });
  };

  const resetForm = () => {
    setCustomer({ name: "", email: "", address: "" });
    setInvoice({
      code: `INV-${dayjs().format("YYYYMMDD-HHmmss")}`,
      date: dayjs().format("YYYY-MM-DD"),
      notes: "",
      currency: "INR",
    });
    setItems([{ ...blankItem }]);
    setTaxPct(18);
    setEmailNow(false);
    setEmailTo("");
    setDownloadUrl("");
  };

  const sendExisting = async (fileName, to) => {
    setMailing(true);

    try {
      const response = await fetch(`${Constants.API_URL}/accounts/send`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-role": "account",
        },
        body: JSON.stringify({ fileName, to }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Failed");
      }
    } finally {
      setMailing(false);
    }
  };

  const submit = async () => {
    if (!customer.name.trim()) {
      alert("Please enter customer name");
      return;
    }

    if (!items.some((item) => item.desc && Number(item.amount) > 0)) {
      alert("Please add at least one valid item");
      return;
    }

    setLoading(true);

    try {
      const body = {
        org,
        customer,
        invoice,
        items,
        totals,
        emailNow,
        emailTo,
      };

      const response = await fetch(`${Constants.API_URL}/accounts/invoice`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-role": emailNow ? "account" : "guest",
        },
        body: JSON.stringify(body),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Failed");
      }

      setDownloadUrl(data.url);
      await loadList();

      if (!emailNow) {
        const want = window.confirm(
          "Invoice generated. Do you want to email it now?"
        );

        if (want) {
          const to = prompt(
            "Send to email:",
            customer.email || ""
          );

          if (to !== null) {
            await sendExisting(data.fileName, to || customer.email);
            alert("Email sent.");
          }
        }
      } else {
        alert("Invoice generated and emailed.");
      }
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  const formatMoney = (amount) => {
    return `₹${Number(amount || 0).toFixed(2)}`;
  };

  return (
    <div className="unit-page invoice-gen-theme">
      <div className="invoice-heading-box">
        <div className="invoice-heading-content">
          <div className="invoice-heading-icon">
            <i className="fa-solid fa-file-invoice-dollar" aria-hidden="true"></i>
          </div>

          <div>
            <div className="unit-page-label">Accounts</div>
            <h2>Invoice Generator</h2>
            <p>Create invoices, upload logo/signature, generate PDF and email invoices.</p>
          </div>
        </div>

        <div className="unit-header-actions">
          <button className="unit-btn unit-btn-light" onClick={loadList}>
            <i className="fa-solid fa-rotate" aria-hidden="true"></i>
            Refresh
          </button>

          <button className="unit-btn unit-btn-light" onClick={resetForm}>
            <i className="fa-solid fa-rotate-left" aria-hidden="true"></i>
            Reset
          </button>

          <button
            className="unit-btn unit-btn-primary"
            onClick={submit}
            disabled={loading}
          >
            <i className="fa-solid fa-file-pdf" aria-hidden="true"></i>
            {loading ? "Working..." : "Generate PDF"}
          </button>
        </div>
      </div>

      <div className="unit-stats-row invoice-one-line-cards">
        <div className="unit-stat-card invoice-stat-blue">
          <div className="invoice-stat-icon">
            <i className="fa-solid fa-file-invoice" aria-hidden="true"></i>
          </div>
          <div>
            <span>Invoice No.</span>
            <strong className="invoice-stat-code">{invoice.code}</strong>
          </div>
        </div>

        <div className="unit-stat-card invoice-stat-purple">
          <div className="invoice-stat-icon">
            <i className="fa-solid fa-box" aria-hidden="true"></i>
          </div>
          <div>
            <span>Items</span>
            <strong>{items.length}</strong>
          </div>
        </div>

        <div className="unit-stat-card invoice-stat-cyan">
          <div className="invoice-stat-icon">
            <i className="fa-solid fa-sack-dollar" aria-hidden="true"></i>
          </div>
          <div>
            <span>Subtotal</span>
            <strong>{formatMoney(totals.subtotal)}</strong>
          </div>
        </div>

        <div className="unit-stat-card invoice-stat-orange">
          <div className="invoice-stat-icon">
            <i className="fa-solid fa-percent" aria-hidden="true"></i>
          </div>
          <div>
            <span>Tax</span>
            <strong>{formatMoney(totals.taxAmt)}</strong>
          </div>
        </div>

        <div className="unit-stat-card invoice-stat-green">
          <div className="invoice-stat-icon invoice-stat-icon-primary">
            <i className="fa-solid fa-coins" aria-hidden="true"></i>
          </div>
          <div>
            <span>Grand Total</span>
            <strong>{formatMoney(totals.grandTotal)}</strong>
          </div>
        </div>
      </div>

      <div className="row g-4">
        <div className="col-lg-6">
          <div className="unit-card h-100">
            <div className="unit-toolbar">
              <div>
                <h5>
                  <i className="fa-solid fa-building" aria-hidden="true"></i>
                  Organization Details
                </h5>
                <p>Company, tax, logo, signature and bank information.</p>
              </div>
            </div>

            <div className="p-3">
              <div className="row g-3">
                <div className="col-12">
                  <label className="form-label" htmlFor="inv-org-name">Company Name</label>
                  <input
                    id="inv-org-name"
                    className="form-control"
                    value={org.name}
                    onChange={(e) => setOrg({ ...org, name: e.target.value })}
                    placeholder="Company Name"
                  />
                </div>

                <div className="col-12">
                  <label className="form-label" htmlFor="inv-org-address">Address</label>
                  <textarea
                    id="inv-org-address"
                    className="form-control"
                    rows={3}
                    value={org.address}
                    onChange={(e) =>
                      setOrg({ ...org, address: e.target.value })
                    }
                    placeholder="Address"
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label" htmlFor="inv-org-phone">Phone</label>
                  <input
                    id="inv-org-phone"
                    className="form-control"
                    value={org.phone}
                    onChange={(e) => setOrg({ ...org, phone: e.target.value })}
                    placeholder="Phone"
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label" htmlFor="inv-org-email">Email</label>
                  <input
                    id="inv-org-email"
                    className="form-control"
                    value={org.email}
                    onChange={(e) => setOrg({ ...org, email: e.target.value })}
                    placeholder="Email"
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label" htmlFor="inv-org-gstin">GSTIN</label>
                  <input
                    id="inv-org-gstin"
                    className="form-control"
                    value={org.gstin}
                    onChange={(e) => setOrg({ ...org, gstin: e.target.value })}
                    placeholder="GSTIN"
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label" htmlFor="inv-org-pan">PAN</label>
                  <input
                    id="inv-org-pan"
                    className="form-control"
                    value={org.pan}
                    onChange={(e) => setOrg({ ...org, pan: e.target.value })}
                    placeholder="PAN"
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label" htmlFor="inv-org-logo">Logo Upload</label>
                  <input
                    id="inv-org-logo"
                    type="file"
                    accept="image/*"
                    className="form-control"
                    onChange={async (e) => {
                      const file = e.target.files?.[0];
                      if (!file) return;

                      const url = await uploadImage(file);
                      setOrg({ ...org, logoUrl: url });
                      setLogoPreview(url);
                    }}
                  />

                  {(logoPreview || org.logoUrl) && (
                    <img
                      src={logoPreview || org.logoUrl}
                      alt="logo"
                      className="invoice-upload-preview"
                      style={{ height: 48, marginTop: 8 }}
                    />
                  )}
                </div>

                <div className="col-md-6">
                  <label className="form-label" htmlFor="inv-org-signature">Signature Upload</label>
                  <input
                    id="inv-org-signature"
                    type="file"
                    accept="image/*"
                    className="form-control"
                    onChange={async (e) => {
                      const file = e.target.files?.[0];
                      if (!file) return;

                      const url = await uploadImage(file);
                      setOrg({ ...org, signatureUrl: url });
                      setSignPreview(url);
                    }}
                  />

                  {(signPreview || org.signatureUrl) && (
                    <img
                      src={signPreview || org.signatureUrl}
                      alt="signature"
                      className="invoice-upload-preview"
                      style={{ height: 48, marginTop: 8 }}
                    />
                  )}
                </div>

                <div className="col-md-6">
                  <label className="form-label" htmlFor="inv-org-color-primary">Brand Color</label>
                  <input
                    id="inv-org-color-primary"
                    type="color"
                    className="form-control form-control-color"
                    value={org.theme.primary}
                    onChange={(e) =>
                      setOrg({
                        ...org,
                        theme: { ...org.theme, primary: e.target.value },
                      })
                    }
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label" htmlFor="inv-org-color-accent">Accent Color</label>
                  <input
                    id="inv-org-color-accent"
                    type="color"
                    className="form-control form-control-color"
                    value={org.theme.accent}
                    onChange={(e) =>
                      setOrg({
                        ...org,
                        theme: { ...org.theme, accent: e.target.value },
                      })
                    }
                  />
                </div>

                <div className="col-12">
                  <h6 className="mt-2 mb-0">Bank Details</h6>
                </div>

                <div className="col-12">
                  <input
                    className="form-control"
                    placeholder="Bank Name"
                    aria-label="Bank Name"
                    value={org.bank.name}
                    onChange={(e) =>
                      setOrg({
                        ...org,
                        bank: { ...org.bank, name: e.target.value },
                      })
                    }
                  />
                </div>

                <div className="col-md-6">
                  <input
                    className="form-control"
                    placeholder="A/C No"
                    aria-label="Account Number"
                    value={org.bank.accNo}
                    onChange={(e) =>
                      setOrg({
                        ...org,
                        bank: { ...org.bank, accNo: e.target.value },
                      })
                    }
                  />
                </div>

                <div className="col-md-6">
                  <input
                    className="form-control"
                    placeholder="IFSC"
                    aria-label="IFSC Code"
                    value={org.bank.ifsc}
                    onChange={(e) =>
                      setOrg({
                        ...org,
                        bank: { ...org.bank, ifsc: e.target.value },
                      })
                    }
                  />
                </div>

                <div className="col-12">
                  <input
                    className="form-control"
                    placeholder="Branch"
                    aria-label="Branch"
                    value={org.bank.branch}
                    onChange={(e) =>
                      setOrg({
                        ...org,
                        bank: { ...org.bank, branch: e.target.value },
                      })
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-6">
          <div className="unit-card h-100">
            <div className="unit-toolbar">
              <div>
                <h5>
                  <i className="fa-solid fa-user" aria-hidden="true"></i>
                  Customer & Invoice
                </h5>
                <p>Customer contact, invoice code, date and notes.</p>
              </div>
            </div>

            <div className="p-3">
              <div className="row g-3">
                <div className="col-12">
                  <label className="form-label" htmlFor="inv-cust-name">Customer Name</label>
                  <input
                    id="inv-cust-name"
                    className="form-control"
                    value={customer.name}
                    onChange={(e) =>
                      setCustomer({ ...customer, name: e.target.value })
                    }
                    placeholder="Customer Name"
                  />
                </div>

                <div className="col-12">
                  <label className="form-label" htmlFor="inv-cust-email">Customer Email</label>
                  <input
                    id="inv-cust-email"
                    className="form-control"
                    value={customer.email}
                    onChange={(e) =>
                      setCustomer({ ...customer, email: e.target.value })
                    }
                    placeholder="Customer Email"
                  />
                </div>

                <div className="col-12">
                  <label className="form-label" htmlFor="inv-cust-address">Customer Address</label>
                  <textarea
                    id="inv-cust-address"
                    className="form-control"
                    rows={3}
                    value={customer.address}
                    onChange={(e) =>
                      setCustomer({ ...customer, address: e.target.value })
                    }
                    placeholder="Customer Address"
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label" htmlFor="inv-code">Invoice Code</label>
                  <input
                    id="inv-code"
                    className="form-control"
                    value={invoice.code}
                    onChange={(e) =>
                      setInvoice({ ...invoice, code: e.target.value })
                    }
                    placeholder="Invoice Code"
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label" htmlFor="inv-date">Invoice Date</label>
                  <input
                    id="inv-date"
                    className="form-control"
                    type="date"
                    value={invoice.date}
                    onChange={(e) =>
                      setInvoice({ ...invoice, date: e.target.value })
                    }
                  />
                </div>

                <div className="col-12">
                  <label className="form-label" htmlFor="inv-notes">Notes</label>
                  <textarea
                    id="inv-notes"
                    className="form-control"
                    rows={3}
                    value={invoice.notes}
                    onChange={(e) =>
                      setInvoice({ ...invoice, notes: e.target.value })
                    }
                    placeholder="Invoice notes"
                  />
                </div>

                <div className="col-12">
                  <div className="unit-card invoice-email-option-card">
                    <div className="p-3">
                      <h6 className="mb-2">Email Option</h6>

                      <label className="d-flex align-items-center gap-2">
                        <input
                          type="checkbox"
                          checked={emailNow}
                          onChange={(e) => setEmailNow(e.target.checked)}
                        />
                        Email invoice now
                      </label>

                      {emailNow && (
                        <input
                          className="form-control mt-3"
                          placeholder="Send to email, optional"
                          aria-label="Send invoice to email"
                          value={emailTo}
                          onChange={(e) => setEmailTo(e.target.value)}
                        />
                      )}

                      {downloadUrl && (
                        <a
                          href={downloadUrl}
                          target="_blank"
                          rel="noreferrer"
                          className="unit-btn unit-btn-light text-decoration-none mt-3 d-inline-block"
                        >
                          <i className="fa-solid fa-download" aria-hidden="true"></i>
                          Download Last PDF
                        </a>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Items */}
      <div className="unit-card mt-4">
        <div className="unit-toolbar">
          <div>
            <h5>
              <i className="fa-solid fa-list-check" aria-hidden="true"></i>
              Invoice Items
            </h5>
            <p>Add product/service rows with quantity, rate and calculated amount.</p>
          </div>

          <button className="unit-btn unit-btn-primary" onClick={addItem}>
            <i className="fa-solid fa-plus" aria-hidden="true"></i>
            Add Item
          </button>
        </div>

        <div className="unit-table-wrapper">
          <table className="table unit-table">
            <thead>
              <tr>
                <th>Description</th>
                <th style={{ width: "130px" }}>Qty</th>
                <th style={{ width: "150px" }}>Rate</th>
                <th style={{ width: "160px" }}>Amount</th>
                <th className="text-end" style={{ width: "90px" }}>
                  Action
                </th>
              </tr>
            </thead>

            <tbody>
              {items.map((item, index) => (
                <tr key={index}>
                  <td className="invoice-item-desc">
                    <input
                      className="form-control"
                      value={item.desc}
                      onChange={(e) =>
                        setItem(index, { desc: e.target.value })
                      }
                      placeholder="Description"
                      aria-label={`Item ${index + 1} description`}
                    />
                  </td>

                  <td>
                    <input
                      className="form-control"
                      type="number"
                      step="0.01"
                      value={item.qty}
                      onChange={(e) =>
                        setItem(index, { qty: e.target.value })
                      }
                      aria-label={`Item ${index + 1} quantity`}
                    />
                  </td>

                  <td>
                    <input
                      className="form-control"
                      type="number"
                      step="0.01"
                      value={item.rate}
                      onChange={(e) =>
                        setItem(index, { rate: e.target.value })
                      }
                      aria-label={`Item ${index + 1} rate`}
                    />
                  </td>

                  <td>
                    <input
                      className="form-control"
                      readOnly
                      type="number"
                      step="0.01"
                      value={item.amount ?? 0}
                      aria-label={`Item ${index + 1} amount`}
                    />
                  </td>

                  <td>
                    <div className="unit-actions">
                      <button
                        className="unit-icon-btn unit-delete"
                        onClick={() => removeItem(index)}
                        disabled={items.length === 1}
                        title="Remove item"
                        aria-label={`Remove item ${index + 1}`}
                      >
                        <i className="fa-solid fa-trash" aria-hidden="true"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="p-3 border-top">
          <div className="row g-3 align-items-end">
            <div className="col-md-2">
              <label className="form-label" htmlFor="inv-tax-pct">Tax %</label>
              <input
                id="inv-tax-pct"
                className="form-control"
                type="number"
                step="0.01"
                value={taxPct}
                onChange={(e) => setTaxPct(e.target.value)}
              />
            </div>

            <div className="col-md-10">
              <div className="invoice-total-strip">
                <div>
                  <span>Subtotal</span>
                  <strong>{formatMoney(totals.subtotal)}</strong>
                </div>

                <div>
                  <span>Tax</span>
                  <strong>{formatMoney(totals.taxAmt)}</strong>
                </div>

                <div>
                  <span>Grand Total</span>
                  <strong>{formatMoney(totals.grandTotal)}</strong>
                </div>

                <button
                  className="unit-btn unit-btn-primary"
                  onClick={submit}
                  disabled={loading}
                >
                  <i className="fa-solid fa-file-pdf" aria-hidden="true"></i>
                  {loading ? "Working..." : "Generate PDF"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Generated Invoices */}
      <div className="unit-card mt-4">
        <div className="unit-toolbar">
          <div>
            <h5>
              <i className="fa-solid fa-file-invoice" aria-hidden="true"></i>
              Generated Invoices
            </h5>
            <p>View, download and email previously generated invoice PDFs.</p>
          </div>
        </div>

        <div className="unit-table-wrapper">
          <table className="table unit-table">
            <thead>
              <tr>
                <th>File</th>
                <th>Size</th>
                <th>Modified</th>
                <th className="text-end" style={{ width: "230px" }}>
                  Actions
                </th>
              </tr>
            </thead>

            <tbody>
              {list.length > 0 ? (
                list.map((file) => (
                  <tr key={file.fileName}>
                    <td>
                      <div className="unit-name-box">
                        <div className="unit-letter">I</div>

                        <div>
                          <a
                            href={file.url}
                            target="_blank"
                            rel="noreferrer"
                            className="text-decoration-none"
                          >
                            <strong>{file.fileName}</strong>
                          </a>
                          <small>Invoice PDF</small>
                        </div>
                      </div>
                    </td>

                    <td>
                      <span className="unit-id">
                        {(file.size / 1024).toFixed(1)} KB
                      </span>
                    </td>

                    <td>
                      {dayjs(file.mtime).format("YYYY-MM-DD HH:mm")}
                    </td>

                    <td>
                      <div className="unit-actions">
                        <button
                          className="unit-btn unit-btn-light"
                          disabled={mailing}
                          aria-label={`Email ${file.fileName}`}
                          onClick={async () => {
                            const to = prompt("Email to:", customer.email || "");

                            if (to) {
                              await sendExisting(file.fileName, to);
                              alert("Email sent.");
                            }
                          }}
                        >
                          <i className="fa-solid fa-envelope" aria-hidden="true"></i>
                          Email
                        </button>

                        <a
                          href={file.url}
                          target="_blank"
                          rel="noreferrer"
                          className="unit-btn unit-btn-light text-decoration-none"
                          aria-label={`Download ${file.fileName}`}
                        >
                          <i className="fa-solid fa-download" aria-hidden="true"></i>
                          Download
                        </a>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4">
                    <div className="unit-empty">
                      <div className="unit-empty-icon">
                        <i className="fa-solid fa-file-invoice" aria-hidden="true"></i>
                      </div>
                      <h5>No invoices yet</h5>
                      <p>Generated invoices will appear here.</p>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

    </div>
  );
}